/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaSingleBurnerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxSedonaSingleBurner').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'BURNER_LYNX_LSB501',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-single-burner.js.map